import { MessageCircle } from "lucide-react";
import type { ReactNode } from "react";
import { buildWhatsAppUrl } from "../../lib/whatsapp";

type WhatsAppLinkProps = {
  children: ReactNode;
  message?: string;
  className?: string;
  showIcon?: boolean;
};

export function WhatsAppLink({ children, message, className = "button button--primary", showIcon = true }: WhatsAppLinkProps) {
  return (
    <a
      href={buildWhatsAppUrl(message)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label={`${typeof children === "string" ? children : "Contactar"} pelo WhatsApp`}
    >
      {showIcon && <MessageCircle size={19} aria-hidden="true" />}
      {children}
    </a>
  );
}
